/** Deterministic PRNG so the server and client render the same starfield. */
function mulberry32(seed: number) {
  return () => {
    seed = (seed + 0x6d2b79f5) | 0
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/** One box-shadow per star, positioned in viewport units so the field fills any screen. */
function stars(count: number, seed: number, colors: string[]) {
  const rand = mulberry32(seed)
  return Array.from({ length: count }, () => {
    const color = colors[Math.floor(rand() * colors.length)]
    return `${(rand() * 100).toFixed(2)}vw ${(rand() * 100).toFixed(2)}vh ${color}`
  }).join(', ')
}

const LAYERS = [
  { size: 1, shadow: stars(160, 1, ['rgba(255,255,255,0.55)', 'rgba(200,210,255,0.45)']), twinkle: '' },
  { size: 2, shadow: stars(50, 2, ['rgba(255,255,255,0.8)', 'rgba(34,211,238,0.7)']), twinkle: 'motion-safe:animate-[twinkle_6s_ease-in-out_infinite]' },
  { size: 2, shadow: stars(18, 3, ['rgba(255,46,146,0.8)', 'rgba(255,212,0,0.7)', '#ffffff']), twinkle: 'motion-safe:animate-[twinkle_9s_ease-in-out_3s_infinite]' },
]

/**
 * The homepage's space backdrop without the 3D globe: the same deep-violet gradient plus a static
 * CSS starfield standing in for the model's star dome. No JavaScript, no WebGL.
 */
export default function SpaceBackdrop() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at 50% 40%, #1d1240 0%, #120c2b 45%, var(--flagship-bg) 100%)',
        }}
      />
      {LAYERS.map((layer, i) => (
        <div
          key={i}
          className={`absolute top-0 left-0 rounded-full ${layer.twinkle}`}
          style={{ width: layer.size, height: layer.size, boxShadow: layer.shadow }}
        />
      ))}
      {/* soft nebula glows in the brand colours */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(40% 35% at 15% 20%, rgba(34,211,238,0.10), transparent 70%), radial-gradient(45% 40% at 85% 75%, rgba(255,46,146,0.10), transparent 70%)',
        }}
      />
    </div>
  )
}
